import Header from '../../../pages/structure/Header/Header'
import * as React from 'react'
import ApiCall from '../../../components/ApiCall/ApiCall'
import { Alert, Card } from 'react-bootstrap'
import SettingsInterface from '../../../components/UserProfil/Settings/SettingsInterface';
import AccountParametersSettings from './AccountParametersSettings';
import Footer from '../../../pages/structure/Footer/Footer';
import img_profile from './../../../Icone/undraw_profile.png'
require('../settings.css')
/*
	this class is the main file of the settings page "Mes Informations" for the email and the name
*/
interface SettingsProps {
	[key : string]: any
}

export default class Settings extends React.Component<SettingsProps, SettingsInterface> {


	private api = new ApiCall()

    constructor (props: SettingsProps) {
		super(props)
        this.state = {
			email: "",
			errorEmail: "",
			active: false,
			gender: false,
            name: "",
            errorName: "",
			location: "",
			research: false,
            error: false,
            message: ""
        }
	}

	componentDidMount = async () => {
		const request = await this.api.ApiCall("users/me", "GET", {}, localStorage.getItem('AccessToken'))
		
		if(request.status === 200)
		{
			this.setState({
				email : request.data.email,
				name : request.data.name
			})
		}
		else {
			/*redirect accueil*/
		}
	}

    writeError() {
        let {error, message} = this.state

        if (error === true) {
            return (
                <>
                    <Alert variant="danger">
                        {message}
                    </Alert>
                </>
            );
        } else if (message !== "") {
            return (
                <>
                    <Alert variant="success">
                        {message}
                    </Alert>
                </>
            );
        }
	}
	
	generateBody = () => {
		var body:SettingsProps = {}
		if (this.state.email !== "")
			body['email'] = this.state.email
		if (this.state.name !== "")
			body['name'] = this.state.name
		return body
	}

	submitNewInformation = async () => {
		const request = await this.api.ApiCall("users/me", "PATCH",
		this.generateBody(), localStorage.getItem('AccessToken'))
		if(request.status === 204)
		{
			this.setState({
                error: false,
                message: "Vos informations ont bien été modifiées."
            })
		}
		else {
			this.setState({
                error: true,
                message: "Erreur lors de la modification de vos informations."
            })
		}
	}

    handleChange = (event: React.FormEvent<HTMLInputElement>, target: string) => {
		this.setState({
			[target]: (event.target as HTMLInputElement).value
		} as any);
	}

    render () {
		if (localStorage.getItem('AccessToken') === null) {
			return (
				<>
					<Header/>
					{ this.writeError() }
				</>
			);
		}
		return (
			<>
				<div id="other_canv">
					<div id="particles-js">
					<Header/>
						<div className="hero-wrap js-fullheight">
							<div className="overlay"></div>
							<div className="container">
								<div className="row no-gutters slider-text align-items-center justify-content-center" data-scrollax-parent="true">
									<div id="border-search" className="col-md-6 ftco-animate text-center fadeInUp ftco-animated" data-scrollax=" properties: { translateY: '70%' }">
										<br></br>
										<br></br>
										<h1 className="mb-3 bread" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
										Mes Informations
										</h1>
									</div>
								</div>
							</div>
						</div>
					</div>
				<section>
					<div className={"boddy-settings"}>
						<div  className={"title-settings"}>
							{ this.writeError() }
							<h3>Vous pouvez modifier votre E-mail ainsi que votre nom sur cette page</h3>
							<br/>
							<img alt="profile" src={img_profile} width="20%" height="20%"></img>
						</div>
						<div>
							<Card>
								<Card.Body>
									<div className={"container"}>
										<AccountParametersSettings
											state={this.state}
											handleChange={this.handleChange}
											submitNewInformation={this.submitNewInformation}/>
									</div>
								</Card.Body>
							</Card>
						</div>
					</div>
				</section>
				<Footer></Footer>
				</div>
			</>
		);
    }
	
}